import React from 'react';
import { XStack } from '@tamagui/stacks';
import { X as XIcon, Heart, Star } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import { IconButton } from '@/components';

const BUTTON_SIZE_SMALL = 80;
const BUTTON_SIZE_LARGE = 110;
const ICON_SIZE_SMALL = 28;
const ICON_SIZE_LARGE = 52;

type ActionsBarProps = {
  onDiscard: () => void;
  onLike: () => void;
  onFavorite: () => void;
};

const ActionsBar = React.memo<ActionsBarProps>(({ onDiscard, onLike, onFavorite }) => {
  return (
    <XStack 
      alignItems="center" 
      justifyContent="center" 
      gap="$5"
      paddingVertical="$2"
      backgroundColor="transparent"
    >
      <IconButton
        accessibilityLabel="Discard"
        onPress={onDiscard}
        style={{
          width: BUTTON_SIZE_SMALL,
          height: BUTTON_SIZE_SMALL,
          borderRadius: BUTTON_SIZE_SMALL / 2,
          backgroundColor: COLORS.WHITE,
          borderWidth: 2,
          borderColor: COLORS.WHITE,
          shadowColor: COLORS.BLACK,
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowOpacity: 0.3,
          shadowRadius: 1,
          elevation: 1,
        }}
      >
        <XIcon size={ICON_SIZE_SMALL} color={COLORS.DARK_TEXT}  />
      </IconButton>

      <IconButton
        accessibilityLabel="Like"
        onPress={onLike}
        style={{
          width: BUTTON_SIZE_LARGE,
          height: BUTTON_SIZE_LARGE,
          borderRadius: BUTTON_SIZE_LARGE / 2,
          backgroundColor: COLORS.WHITE,
          borderWidth: 2,
          borderColor: COLORS.WHITE,
          shadowColor: COLORS.ERROR,
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowOpacity: 0.1,
          shadowRadius: 10,
          elevation: 30,
        }}
      >
        <Heart size={ICON_SIZE_LARGE} color={COLORS.ERROR} fill={COLORS.ERROR} />
      </IconButton>

      <IconButton
        accessibilityLabel="Favorite"
        onPress={onFavorite}
        style={{
          width: BUTTON_SIZE_SMALL,
          height: BUTTON_SIZE_SMALL,
          borderRadius: BUTTON_SIZE_SMALL / 2,
          backgroundColor: COLORS.WHITE,
          borderWidth: 2,
          borderColor: COLORS.WHITE,
          shadowColor: COLORS.BLACK,
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowOpacity: 0.1,
          shadowRadius: 1,
          elevation: 1,
        }}
      >
        <Star size={ICON_SIZE_SMALL} color={COLORS.DARK_TEXT} fill={COLORS.DARK_TEXT} />
      </IconButton>
    </XStack>
  );
});

ActionsBar.displayName = 'ActionsBar';

export default ActionsBar;

